import type React from 'react';

import { ClickAwayListener } from '@mui/material';
import Tooltip, { type TooltipProps } from '@mui/material/Tooltip';

import { useStylesTooltip } from 'components/tooltip/styles';

const TMXTooltip: React.FC<React.PropsWithChildren<TooltipProps>> = ({ children, ...props }) => {
  const { classes: tooltipClasses } = useStylesTooltip();

  const handleClickAway = (event) => {
    if (props.onClose) {
      props.onClose(event);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Tooltip
        disableFocusListener
        disableHoverListener
        disableTouchListener
        {...props}
        classes={{ ...tooltipClasses, ...props.classes }}
      >
        {children}
      </Tooltip>
    </ClickAwayListener>
  );
};

export default TMXTooltip;
